<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" style="padding-bottom: 10px !important;">

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs row">
                        <div class="col-xs-12 col-sm-fill hidden-xs">
                            <h3>
                                <i class="las" :class="$router.currentRoute.meta.icon"></i>
                                {{$router.currentRoute.meta.title}}
                            </h3>
                        </div>
                    </div>

                    <div class="row" v-if="detalhes">
                        <div class="col-xs-12 col-lg-4">
                            <div class="card"  style="overflow-y: auto; overflow-x: hidden; height: calc(100vh - 190px);">
                                <div class="list-small ">
                                    <div class="row margin-bottom-20" style="">
                                        <div class="col-xl-12">
                                            <h4>
                                                <i class="las la-file"></i> <b>Nome:</b> {{detalhes.nome}}
                                            </h4>
                                            <h4>
                                                <i class="las la-info-circle"></i>
                                                <b>Status:</b> 
                                                <a style="position: relative; margin-top: 0px;" class="dashboard-status-button margin-left-5 color-orange" v-if="detalhes.status == 0">
                                                    Pendente
                                                </a>
                                                <a style="position: relative; margin-top: 0px;" class="dashboard-status-button margin-left-5 color-blue" v-if="detalhes.status == 1">
                                                    Em andamento
                                                </a>
                                                <a style="position: relative; margin-top: 0px;" class="dashboard-status-button margin-left-5 color-red" v-if="detalhes.status == -1">
                                                    Cancelado
                                                </a>
                                                <a style="position: relative; margin-top: 0px;" class="dashboard-status-button margin-left-5 color-green" v-if="detalhes.status == 2">
                                                    Finalizado
                                                </a>                                            
                                            </h4>
                                            <h4>
                                                <i class="las la-map-marker"></i> <b>Locais:</b> {{detalhes.clientes.length}} cliente(s)
                                            </h4>
                                            <h4>
                                                <i class="las la-calendar"></i> <b>Período:</b> {{detalhes.dataInicio | formatDate}} - {{detalhes.dataFinal | formatDate}}
                                            </h4>
                                        </div>
                                    </div>
                                    <div class="row margin-bottom-10" style="">
                                        <div class="col-xl-12 margin-bottom-10">
                                            <button v-if="!(detalhes.status == 0 || detalhes.status == -1 || detalhes.status == 2)" v-on:click="cancelarPendentes()" type="button" class="button small color-orange full-width margin-bottom-10">
                                                <i class="las la-times"></i> Cancelar visitas pendentes
                                            </button>
                                            <button v-if="!(detalhes.status == 0 || detalhes.status == -1 || detalhes.status == 2)" v-on:click="cancelarTodas()" type="button" class="button small color-red full-width margin-bottom-10">
                                                <i class="las la-times"></i> Apagar todas as visitas
                                            </button>
                                        </div>
                                        <div class="col-xl-12">
                                            <p class="alert"><i class="las la-question-circle"></i> Filtre abaixo por dia / equipe, e veja os clientes e rotas planejadas para cada dia.</p>
                                        </div>
                                    </div>
                                    <div class="row margin-bottom-10" style="">
                                        <div class="col-xl-12">
                                            <h4>
                                                <i class="las la-calendar"></i> Dia
                                            </h4>
                                        </div>
                                    </div>                                       
                                    <div class="row margin-bottom-20" style="">
                                        <div class="col-xl-6 col-xs-12">
                                            <select class="with-border" v-model="form.data">
                                                <option v-for="(item, index) in detalhes.dias" :value="item">{{item | formatDate}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="row margin-bottom-10" style="">
                                        <div class="col-xl-12">
                                            <h4>
                                                <i class="las la-file"></i> Equipes
                                            </h4>
                                        </div>
                                    </div>                                    
                                    <div v-on:click="setEquipe(item.cod)" v-bind:class="{'active': item.cod == form.equipeCod}" class="row list click" v-for="(item, index) in detalhes.equipes">
                                        <div class="col-xl-11 col-xs-11">
                                            <h5>{{item.nome}}</h5>
                                            <small>{{item.quantidadeVisitas}} cliente(s) / {{item.quantidadeDias}} dia(s)</small>
                                        </div>
                                        <div  class="col-xl-1 col-xs-1" style="position: relative;">
                                            <i class="las la-angle-right" style="margin-top: 12px"></i>
                                        </div>
                                    </div>

                                    <div class="row margin-bottom-5 margin-top-25" style="">
                                        <div class="col-xl-12">
                                            <h4>
                                                <i class="las la-users"></i> Clientes do dia
                                            </h4>
                                        </div>
                                    </div>                                    
                                    <div  class="row list " v-for="(item, index) in detalhes.visitas" v-if="item.data == form.data && item.equipeCod == form.equipeCod">
                                        <div class="col-xl-12 col-xs-12">
                                            <h5>{{item.cliente.empresa ? item.cliente.empresa : item.cliente.nome}}</h5>
                                            <small>{{item.cliente.endereco}}, {{item.cliente.numero != '' ? item.cliente.numero : 's/n'}}. {{item.cliente.cep}}. {{item.cliente.bairro}}. {{item.cliente.cidade}} - {{item.cliente.estado}}</small>
                                            <span v-if="item.status == 0" class="dashboard-status-button color-orange">
                                                Pendente
                                            </span>
                                            <span v-if="item.status == 1" class="dashboard-status-button color-blue">
                                                Em andamento
                                            </span>
                                            <span v-if="item.status == 2" class="dashboard-status-button color-green">
                                                Concluída
                                            </span>
                                            <span v-if="item.status == -1" class="dashboard-status-button color-red">
                                                Cancelada
                                            </span>           

                                            <router-link :to="{'name': 'EditarAgendamentos', 'query': {'c': item.cod}}" class="float-right link" target="_blank"><i class="las la-external-link-alt"></i> Visualizar visita</router-link>

                                        </div>
                                    </div>                                    
                                
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-lg-8" style=" height: calc(100vh - 190px)">
                            <div class="mapa" style="width: 100%; height: 100%;"></div>
                        </div>
                    </div>                

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'
import AvatarCropper from "vue-avatar-cropper"

export default {
    name: 'DetalhesPlanejamentos',
    components: {
        'AvatarCropper': AvatarCropper,
        'Top':      Top,
        'Sidebar':  Sidebar,
        'Toolbar':  Toolbar
    },          
    data () {
        var self                    = this;
        return {
            "detalhes":             null,
            "equipes": {
                "itens":            []
            },
            "markers":              {},
            "clientes": {
                "itens":            [],
                "pesquisa":         [],
                "nome":             "",
                "mostrar":          false
            },            
            "form": {
                "_cod":                 "",
                "_token":               "",
                "data":                 "",
                "equipeCod":            ""
            },    
        }
    },
    filters: {
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toFixed(2).toLocaleString('pt-br', {minimumFractionDigits: 2});
            } else {
                return "0.00";
            }
        },        
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }
            return date + (time ? (" " + time) : "");
        }
    },      
    computed: {

    },
    watch: {
        "form.data": function(val) {
            var self = this;
            console.log("watch form.data", val);
            if (self.directionsService) self.atualizarMapa();
        },
        "form.equipeCod": function(val) {
            var self = this;
            console.log("watch form.equipeCod", val);
            if (self.directionsService) self.atualizarMapa();
        },        
    },    
    methods: {
        setEquipe: function(cod) {
            var self        = this;
            console.log("setEquipe()", cod);
            self.form.equipeCod = cod;
            self.$forceUpdate();
        },      
        cancelarPendentes: function(e) {
            var self            = this;
            console.log("cancelarPendentes()") 

            confirm("Você tem certeza que deseja cancelar todas as visitas pendentes desse planejamento? Atenção, essa ação não poderá ser desfeita.", function() {

                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "cod":          self.form.cod,
                    "acao":         "cancelar-visitas"
                };
                loading.show();
                
                axios.put("api/planejamentos.php", form)
                .then(response => {
                    loading.hide();
                    console.log("cancelarPendentes() response", response)
                    alert(response.data.message);
                    self.init();
                })
                .catch(error => {
                    console.log("cancelarPendentes() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });

        },
        cancelarTodas: function(e) {
            var self            = this;
            console.log("cancelarTodas()") 

            confirm("Você tem certeza que deseja apagar todas as visitas desse planejamento? Atenção, essa ação não poderá ser desfeita.", function() {

                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "cod":          self.form.cod,
                    "acao":         "apagar-visitas"
                };
                loading.show();
                
                axios.put("api/planejamentos.php", form)
                .then(response => {
                    loading.hide();
                    console.log("cancelarTodas() response", response)
                    alert(response.data.message);
                    self.init();
                })
                .catch(error => {
                    console.log("cancelarTodas() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });            
        },              
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/planejamentos.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.detalhes       = response.data.result;
                    self.loaded         = true;
                    // loading.hide();
                    self.$forceUpdate();

                    // self.initMapa();

                    setTimeout(function() {
                        if (!self.form.data && response.data.result.dias.length > 0) {
                            self.form.data = response.data.result.dias[0];
                        }

                        if (!self.form.equipeCod && response.data.result.equipes.length > 0) {
                            self.form.equipeCod = response.data.result.equipes[0]["cod"];
                        }
                        self.$forceUpdate();
                    }, 1000);

                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar?", function() {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          cod
                    }
                };
                loading.show();
                
                axios.delete("api/planejamentos.php", form)
                .then(response => {
                    console.log("del() response", response)
                    self.$root.back();
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },
        initMapa: function() {
            console.log("initMapa()");
            var self                = this;
                    
            self.mapaCentro         = { lat: parseFloat(self.detalhes.origemLatitude), lng: parseFloat(self.detalhes.origemLongitude) };

            setTimeout(function() {

                self.mapa       = new google.maps.Map($(".mapa")[0], {
                    center:     self.mapaCentro,
                    zoom:       12,
                    disableDefaultUI: true,
                });

                self.directionsService      = new google.maps.DirectionsService();
                self.directionsRenderer     = new google.maps.DirectionsRenderer({
                    markerOptions: {
                        // icon: {
                        //     url: ""
                        // }
                    }
                });
                self.directionsRenderer.setMap(self.mapa);
            }, 500);
        },
        atualizarMapa: function() {
            var self = this;

            if (!self.form.equipeCod || !self.form.data) return false;
            loading.show();
            console.log("atualizarMapa()");

            Object.keys(self.markers).forEach(function(item) {
                // console.log("MARKER>", self.markers[item])
                self.markers[item].setMap(null);
            });

            
            var waypoints   = [];
            self.detalhes.visitas.forEach(function(item, index) {

                if (item.data == self.form.data && item.equipeCod == self.form.equipeCod && (index < self.detalhes.visitas.length)) {
                    var location = item.cliente.latitude + "," + item.cliente.longitude;
                    console.log(">", location);
                    waypoints.push({"location": location, "stopover": true});
                }

            });


            self.directionsService.route({
                origin: self.mapaCentro,
                waypoints: waypoints,
                destination: waypoints[ waypoints.length - 1 ]["location"],
                optimizeWaypoints: true,
                travelMode: google.maps.TravelMode.DRIVING,
            })
            .then((response) => {
                console.log("directionsService.route()", response);
                self.directionsRenderer.setDirections(response);            
                setTimeout(function() {
                    loading.hide();
                }, 500);
            }).catch(function(error) {
                console.log("directionsService.route() error", error);
                loading.hide();
            });
        },
        init: function() {
            console.log("init()")
            var self = this;
            loading.show();
            self.form.cod = self.$route.query.c;
            Promise.resolve()
            .then(self.get)
            .then(self.initMapa)
            .finally(function() {
                setTimeout(function() {
                    self.atualizarMapa();
                    loading.hide();
                }, 1500);
                console.log("Buscou tudo 1>")
            })            
        },
        update: function() {
            this.$forceUpdate();
        }
    },    
    created: function() {
        var self = this;
        console.log("created", self);

    },
    activated: function() {
        var self = this;
        if (!self.$route.query.c) {
            self.$root.back();
            return false;
        }
        self.init();
    }    
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .card .dashboard-status-button {
        margin-top: 8px;
    }

    .uploadButton-button {
        display: none !important;
    }        
    .button.gray.block-mobile {
        font-weight: 400;
        border: 1px solid #ddd !important;
    }

    .imagem-preview {
        width: 100%;
        height: 35vh;
        border-radius: 10px;
        margin-bottom: 25px !important;
        background-size: contain;
        background-color: #ddd;
        background-position: center;
        background-repeat: no-repeat;
    }    

    .uploadButton .uploadButton-input {
        opacity: 0 !important;
    }

    .row h4 i {
        color: #000 !important;
    }

    .row.active {
        background: #f7f7f7;
    }

    .row.list {
        padding-bottom: 10px;
        padding-top: 10px;
        padding-left: 10px;
        padding-right: 10px;
        border-bottom: 1px solid #ddd;
    }

    h4 {
        color: #000;
    }

    h5 {
        line-height: 130%;
        margin-bottom: 5px;
        color: #666 !important;
    }

    small {
        line-height: 120%;
        display: block;
    }

    p {
        line-height: 140%;
        display: block;
        color: #888;
    }

    span.dashboard-status-button {
/*        display: inline-block; text-align: center; margin-top: 3px;        */
    }

    .link {
        font-size: 14px;
        text-decoration: underline !important;
        color: blue;
        margin-top: 6px;
        cursor: pointer !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/DetalhesPlanejamentos.vue